/**
 * /agents — list + create + edit AgentSpec.
 *
 * Mirrors the old Next.js RSC at `app/(dashboard)/agents/page.tsx`. Identity
 * comes from the dashboard-shell auth context (no extra ``/v1/me`` RTT);
 * loader fetches just the team's KB list for the KB picker.
 */

import { useLoaderData } from "react-router-dom";

import { PageHeader } from "@/components/page-header";
import { AgentsBrowser } from "@/features/agents/agents-browser";
import { api } from "@/lib/api";
import type { KbView } from "@/lib/types";

import { useAuthState } from "../lib/auth";

interface AgentsLoaderData {
  kbs: KbView[];
}

export async function agentsLoader(): Promise<AgentsLoaderData> {
  const kbs = await api<KbView[]>("/kbs");
  return { kbs };
}

export default function AgentsRoute() {
  const { kbs } = useLoaderData() as AgentsLoaderData;
  const auth = useAuthState();
  const isAdmin = auth.tenant.role === "team_admin";
  return (
    <section className="space-y-4">
      <PageHeader
        eyebrow="workspace"
        title="Agents"
        subtitle="Define agents (system prompt + model + tools + KB) once, and reuse them across chat, channels, and the API. Each spec change creates a new immutable version so /chat stays reproducible."
      />
      <AgentsBrowser isAdmin={isAdmin} kbs={kbs} />
    </section>
  );
}
